<template>
  <div>
    <div class="sec-menu" v-for="(subItem,index) in subMenuList.subMenuList" :key="index">
      <!-- 二级菜单 -->
      <el-submenu
        v-if="subItem.subMenuList.length>0"
        :index="subItem.id.toString()"    
        :class="{ 'firstLevel': subItem.level==2,'secondLevel':subItem.level==3}"    
      >
        <template slot="title">
           <img
            v-if="subItem.level==2"
            src="@/assets/images/leftmenu/icon_pmenu.png"
            alt
          />
          <img
            v-if="subItem.level==3"
            src="@/assets/images/leftmenu/icon_cmenu.png"
            alt
          />
          <!-- <img  class="firstLevelImg" /> -->
          <span class="menuTitle">{{subItem.name}}</span>
            <!-- <i class="el-submenu__icon-arrow el-icon-caret-bottom"></i> -->
        </template>
        <NavSubMenu :subMenuList="subItem"></NavSubMenu>
      </el-submenu>
      <!-- 二级菜单 -->
      <el-menu-item
        v-else
        :index="subItem.id.toString()"   
        :class="{ 'firstLevel': subItem.level==2,'secondLevel':subItem.level==3,'lastLevel': subItem.level==4}"    
      >
        <template slot="title">
            <img v-if="subItem.level==2" class="firstLevelImg" />
          <img v-if="subItem.level==3" class="secondLevelImg" />        
          <span class="menuTitle">{{subItem.name}}</span>
          <!-- <span class="redPoint" v-show="subItem.showRed"></span> -->
        </template>
      </el-menu-item>
    </div>
  </div>
</template>
<script>
export default {
  name: "NavSubMenu",
  props: ["subMenuList"],
  data() {
    return {};
  }
};
</script>
<style scoped lang="scss">
.menuTitle{
  margin-left: 16px;
}
.redPoint{
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #FF5959;
  position: absolute;
  left: 90px;
  bottom: 20px;
}
/deep/.el-submenu__title {
  font-size: 18px;
  line-height: 76px;
  height: 76px;
  padding: 0 20px !important;
  .is-opened {
    color: #fff !important;
  }
}
/deep/.sec-menu .el-menu-item {
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  background-color: #03131f !important;
  padding: 0 20px !important;
}
/deep/.sec-menu .firstLevel .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
  font-size: 16px !important;
  background-color: #0d2639 !important;
  color: #A3BFCD !important;
}
/deep/.sec-menu .el-menu-item.firstLevel {
  align-items: center;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  background-color: #0d2639 !important;
  padding: 0 20px !important;
  color: #A3BFCD !important;
}

/deep/.sec-menu .secondLevel .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
  font-size: 16px !important;
  background-color: #041C2D !important;
  color: #8FA7B2 !important;
}
/deep/.sec-menu .el-menu-item.secondLevel {
  align-items: center;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  background-color: #041C2D !important;
  padding: 0 20px !important;
  color: #8FA7B2 !important;
}
/deep/.sec-menu .el-menu-item.lastLevel {
  padding-left: 47px !important;
  color: #5C879B !important;
  background-color: #00080E !important;
}
.firstLevelImg {
  content: url("../../assets/images/leftmenu/icon_pmenu.png");
}
.secondLevelImg {
  content: url("../../assets/images/leftmenu/icon_cmenu.png");
}
.el-menu-item.is-active {
  color: #fff !important;
  .menuTitle{
    color: #fff;
  }
  .firstLevelImg {
    content: url("../../assets/images/leftmenu/icon_pmenu_active.png");
  }
  .secondLevelImg {
    content: url("../../assets/images/leftmenu/icon_cmenu_active.png");
  }
}
</style>